// cart-count-fix.js
// Ensures cart bubble updates immediately after Add to Cart on product pages.
(function () {
  function updateCartBubble() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        customElements.whenDefined('cart-icon').then(() => {
          const cartIcon = document.querySelector('cart-icon');
          if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
            cartIcon.renderCartBubble(cart.item_count);
          }
        });
      })
      .catch(() => {});
  }

  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest('product-form-component')) return;
    setTimeout(updateCartBubble, 600);
  });
})();
